/**
 * src/main.tsx — SPA entry point (replaces src/start.ts / SSR entry)
 */
import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { getRouter } from "./router";
import "./integrations/api/sso";

import "./styles.css";

// One shared QueryClient for the entire application.
// Passed into both QueryClientProvider and the TanStack Router context
// so route guards (beforeLoad) and component hooks (useQuery) share
// the same cache — preventing duplicate API calls.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});

const router = getRouter(queryClient);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </React.StrictMode>
);
